import icons from 'url:../../img/icons.svg';
import View from './View.js';
import { RES_PER_PAGE } from '../config.js';

class PaginationView extends View {
  _parentElement = document.querySelector('.pagination');
  _generateMarkup() {
    const numPages = Math.ceil(this._data.results.length / RES_PER_PAGE);

    const currentPage = this._data.page;
    // page one and there are other pages
    if (currentPage === 1 && numPages > 1) {
      return `<button data-goto="${
        currentPage + 1
      }" class="btn--inline pagination__btn--next">
                <span>Page ${currentPage + 1}</span>
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-right"></use>
                </svg>
              </button>`;
    }
    // page one and there are no other pages
    if (currentPage === 1 && numPages === 1) {
      return '';
    }
    // last page and there are previous  pages
    if (currentPage === numPages && numPages !== 1) {
      return `<button data-goto="${
        currentPage - 1
      }" class="btn--inline pagination__btn--prev">
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${currentPage - 1}</span>
              </button>`;
    }
    //  other pages
    if (currentPage < numPages) {
      return `<button data-goto="${
        currentPage - 1
      }" class="btn--inline pagination__btn--prev">
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-left"></use>
                </svg>
                <span>Page ${currentPage - 1}</span>
              </button>
              <button data-goto="${
                currentPage + 1
              }" class="btn--inline pagination__btn--next">
                <span>Page ${currentPage + 1}</span>
                <svg class="search__icon">
                  <use href="${icons}#icon-arrow-right"></use>
                </svg>
              </button>`;
    }
  }
  addHandlerClick(handler) {
    this._parentElement.addEventListener('click', function (e) {
      // if (e.target.closest('.pagination__btn--prev')) {
      //   handler(this._data.page - 1);
      // }
      // if (e.target.closest('.pagination__btn--next')) {
      //   handler(this._data.page + 1);
      // }
      const btn = e.target.closest('.btn--inline');
      if (btn) {
        const gotoPage = +btn.dataset.goto;
        handler(gotoPage);
      }
    });
  }
}
export default new PaginationView();
